module.exports = __webpack_public_path__ + "img/pantreats.7204feb5.png";